// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const workspaceDecisionSchema = z.object({
  "capability": z.enum(["sign_in", "assignments", "request_policy", "diagnostics", "network_access", "automated_onboarding", "application_creation"]),
  "availability": z.enum(["hidden", "read_only", "manage"]),
  "reason_code": z.string().min(1),
  "runtime_effect": z.enum(["legacy_unchanged", "area_gates_offering", "enforced", "observed"])
});

export const applicationWorkspaceCapabilitiesSchema = z.object({
  "data": z.array(workspaceDecisionSchema)
});
